import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../../api/v1";
import { ApiResponse } from "../../../../../../../types/api-response";
import axios from "../../../../../../../utils/axiosInceptor";
import { BillingSchedule, GetBillingScheduleResult } from "./types";

type GetBillingScheduleRequest = {
  leaseId: string;
  commercialBillingSchedule: BillingSchedule[];
};

const getBillingSchedule = async (payload: GetBillingScheduleRequest): Promise<GetBillingScheduleResult> => {
  const url = `${apiV1Endpoint}/booking/paymentScheduleAndTorPeriod`;
  const response = await axios.post<ApiResponse<GetBillingScheduleResult>>(url, payload);
  return response.data.result;
};

type UseGetBillingScheduleOptions = {
  onSuccess?: (data: GetBillingScheduleResult) => void;
  onError?: (error: unknown) => void;
};

export const useGetBillingSchedule = (options: UseGetBillingScheduleOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: getBillingSchedule,
    onSuccess,
    onError,
  });

  return {
    getBillingSchedule: mutateAsync,
    isPendingGetBillingSchedule: isPending,
  };
};
